import { useState } from 'react';
import { categories } from '@/mocks/categories';

export default function CategorySection() {
  const [dropdownOpen, setDropdownOpen] = useState(false);
  const [selectedCategory, setSelectedCategory] = useState('Browse Categories');

  const handleSelect = (cat: typeof categories[0]) => {
    setSelectedCategory(cat.name);
    setDropdownOpen(false);
    window.open(cat.url, '_blank', 'noopener,nofollow');
  };

  return (
    <section id="categories" className="py-16 md:py-20 bg-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-12">
          <h2 className="font-heading text-2xl md:text-4xl font-bold text-foreground-900 mb-3">
            Explore Vigorbuy Spreadsheet Categories
          </h2>
          <p className="text-sm md:text-base text-foreground-600 max-w-2xl mx-auto">
            Browse our organized product categories — each one packed with verified finds, 
            QC photos, and direct links to the best spreadsheet discoveries.
          </p>
        </div>

        <div className="flex justify-center mb-10">
          <div className="relative w-full max-w-md">
            <button
              onClick={() => setDropdownOpen(!dropdownOpen)}
              className="w-full flex items-center justify-between px-5 py-3.5 rounded-xl bg-background-100 border border-background-200/70 text-foreground-800 hover:border-primary-300 transition-all duration-200 cursor-pointer"
            >
              <span className="text-sm font-medium">{selectedCategory}</span>
              <i className={`${dropdownOpen ? 'ri-arrow-up-s-line' : 'ri-arrow-down-s-line'} text-foreground-500 transition-transform duration-200`}></i>
            </button>

            {dropdownOpen && (
              <>
                <div className="fixed inset-0 z-10" onClick={() => setDropdownOpen(false)}></div>
                <div className="absolute top-full left-0 right-0 mt-2 z-20 bg-background-50 border border-background-200/70 rounded-xl shadow-lg overflow-hidden max-h-72 overflow-y-auto">
                  {categories.map((cat) => (
                    <button
                      key={cat.slug}
                      onClick={() => handleSelect(cat)}
                      className="w-full flex items-center gap-3 px-5 py-3 text-sm text-foreground-700 hover:bg-primary-50 hover:text-primary-600 transition-colors duration-150 text-left cursor-pointer whitespace-nowrap"
                    >
                      <span className="w-5 h-5 flex items-center justify-center text-primary-500">
                        <i className={cat.icon}></i>
                      </span>
                      {cat.name}
                    </button>
                  ))}
                </div>
              </>
            )}
          </div>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-4 md:gap-5">
          {categories.map((cat) => (
            <a
              key={cat.slug}
              href={cat.url}
              target="_blank"
              rel="noopener nofollow"
              className="group block rounded-2xl bg-background-100 border border-background-200/70 hover:border-primary-300 hover:shadow-lg transition-all duration-300 cursor-pointer overflow-hidden"
            >
              <div className="relative aspect-[4/3] overflow-hidden">
                <img
                  src={cat.image}
                  alt={`${cat.name} category - Vigorbuy Spreadsheet`}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/40 via-transparent to-transparent"></div>
                <div className="absolute bottom-0 left-0 right-0 p-3">
                  <div className="flex items-center gap-2">
                    <span className="w-7 h-7 flex items-center justify-center rounded-lg bg-background-50/90 text-primary-600">
                      <i className={`${cat.icon} text-sm`}></i>
                    </span>
                    <span className="text-sm font-semibold text-background-50 leading-tight">
                      {cat.name}
                    </span>
                  </div>
                </div>
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}